import { render, staticRenderFns } from "./ThemeSelect.vue?vue&type=template&id=10cbdfa5&"
import script from "./ThemeSelect.vue?vue&type=script&lang=js&"
export * from "./ThemeSelect.vue?vue&type=script&lang=js&"
import style0 from "./ThemeSelect.vue?vue&type=style&index=0&id=10cbdfa5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../backend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports